const siteMetadata = {
  title: 'Mea Menu - La soluzione di riferimento per menu digitali',
  author: 'Bitebooker SRL',
  headerTitle: 'Mea Menu',
  description:
    'Mea Menu è la soluzione digitale che semplifica la gestione del tuo menu, garantendo un servizio dedicato al fianco della tua attività.',
  language: 'it-IT',
  theme: 'system', // system, dark or light
  siteUrl: 'https://meamenu.com',
  siteLogo: '/static/images/logo.png',
  socialBanner: '/static/images/banner-meamenu.png',
  email: 'info@meamenu.com',
  twitter: '@mea_menu',
}

export default siteMetadata
